const transparent = 'transparent'
const current = 'currentColor'
const white = '#fff'
const black = '#000'

const whiteAlpha = {
  50: 'rgba(255, 255, 255, 0.04)',
  100: 'rgba(255, 255, 255, 0.06)',
  200: 'rgba(255, 255, 255, 0.08)',
  300: 'rgba(255, 255, 255, 0.16)',
  400: 'rgba(255, 255, 255, 0.24)',
  500: 'rgba(255, 255, 255, 0.36)',
  600: 'rgba(255, 255, 255, 0.48)',
  700: 'rgba(255, 255, 255, 0.64)',
  800: 'rgba(255, 255, 255, 0.80)',
  900: 'rgba(255, 255, 255, 0.92)',
}

const pink = {
  '50': '#320717',
  '100': '#3b0a1d',
  '200': '#460e23',
  '300': '#691b38',
  '400': '#9d345a',
  '500': '#d76589',
  '600': '#e6809e',
  '700': '#f29cb4',
  '800': '#f8b5c7',
  '900': '#fde0e7',
}

const red = {
  '50': '#350706',
  '100': '#3c0908',
  '200': '#4b0e0c',
  '300': '#6c1c18',
  '400': '#9e3731',
  '500': '#d16e64',
  '600': '#df887e',
  '700': '#eba39a',
  '800': '#f2bab3',
  '900': '#fae2df',
}
const orange = {
  '50': '#271408',
  '100': '#2d180a',
  '200': '#371e0e',
  '300': '#53311a',
  '400': '#804f2d',
  '500': '#be7b4e',
  '600': '#d78e5f',
  '700': '#eda475',
  '800': '#fbb990',
  '900': '#ffe2ce',
}
const yellow = {
  '50': '#2c1209',
  '100': '#32150b',
  '200': '#3c1c0f',
  '300': '#562f1a',
  '400': '#7d502c',
  '500': '#ad8345',
  '600': '#bf9a52',
  '700': '#d0b261',
  '800': '#dfc66d',
  '900': '#f9e6b4',
}
const green = {
  '50': '#051e07',
  '100': '#06230a',
  '200': '#092a0d',
  '300': '#134219',
  '400': '#25672d',
  '500': '#459c4e',
  '600': '#57b260',
  '700': '#71c777',
  '800': '#8fd893',
  '900': '#cef0cf',
}
const teal = {
  '50': '#0a1c1a',
  '100': '#0c201f',
  '200': '#112827',
  '300': '#1e3e3c',
  '400': '#35625f',
  '500': '#5b9490',
  '600': '#70a9a5',
  '700': '#8cbebb',
  '800': '#a7cfcc',
  '900': '#daebea',
}
const cyan = {
  '50': '#0a1b22',
  '100': '#0c1f27',
  '200': '#112731',
  '300': '#1e3d4b',
  '400': '#346074',
  '500': '#5a92ab',
  '600': '#6fa7c0',
  '700': '#8bbcd3',
  '800': '#a6cde1',
  '900': '#daeaf3',
}
const blue = {
  '50': '#091a2c',
  '100': '#0b1e32',
  '200': '#0f253c',
  '300': '#1c3b5b',
  '400': '#315d89',
  '500': '#578ec8',
  '600': '#6ca3dd',
  '700': '#89b9ed',
  '800': '#a4cbf6',
  '900': '#d8e9fc',
}
const purple = {
  '50': '#1f0945',
  '100': '#250c4f',
  '200': '#2d115e',
  '300': '#442186',
  '400': '#6840be',
  '500': '#9478e9',
  '600': '#a691f2',
  '700': '#baaaf8',
  '800': '#cbc0fc',
  '900': '#e8e5fd',
}
const gray = {
  '50': '#19181e',
  '100': '#1e1c23',
  '200': '#25232b',
  '300': '#3a383f',
  '400': '#5b5a60',
  '500': '#8b8a8e',
  '600': '#9f9fa2',
  '700': '#b5b4b7',
  '800': '#c8c7c9',
  '900': '#e8e7e8',
}

export const colors = {
  transparent,
  current,
  white,
  black,
  whiteAlpha,
  gray,
  pink,
  red,
  orange,
  yellow,
  green,
  teal,
  cyan,
  blue,
  purple,
}
